import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { formatDate } from '@angular/common';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import {
  getFormattedDate,
  getFormattedTime,
  getScheduleCellKey,
  getStartAndEndTime,
  getTimerValueDuration,
  isLargeScreen,
  sortArrayOfObject,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { gTDB } from '../../../shared/services/db';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { ClientsService } from '../clients/clients.service';
import { JobsService } from '../jobs/jobs.service';
import { RosterShiftsService } from '../roster-shifts/roster-shifts.service';
import { RosterService } from './roster.service';
import { UsersService } from '../users/users.service';
@Component({
  selector: 'gtapp-roster',
  standalone: false,
  templateUrl: './roster.component.html',
  styleUrl: './roster.component.scss',
})
export class RosterComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;

  currentDay = getFormattedDate();

  availableJobTypes: any = [];
  selectedJobType: any = {};

  selectedSearchDate: any;
  weekDays: any = [];
  isCurrentWeek: boolean = false;
  isPastWeek: boolean = false;

  userListData: any = [];
  userLookupListData: any = [];
  userSearchString: any = '';

  siteListData: any = [];
  siteLookupListData: any = [];

  shiftRecurranceSelection: number = 1;
  selectedShift: any;
  selectedShiftBackup: any;

  // to only call those shifts after updation and not the entire weeks shifts
  updatedShiftIds: any = [];

  shiftApiCallSubject = new Subject<void>();
  routerSubscription!: Subscription;
  shiftSubscription!: Subscription;
  // nextSetPatrolRunsheetSubject = new Subject<void>();

  rosterDataList: any = [];
  filteredRosteredList: any = [];
  filteredRosteredDataStat: any = {};

  rosterGridMap: any = {};

  dataBackupDict: any = { data: [], deletedItems: [] };

  clientDropDownList: any = [];
  clientDropDownBackupList: any = [];
  selectedClient: any = {};

  selectedGlobalAction:
    '' | 'copy' | 'add' | 'move' | 'delete' | 'duplicate' | 'print' = '';

  shiftDataGroupBy: 'person' | 'site' = 'person';

  weatherData: any = {};
  weatherAddressInfo: any = {};

  shiftsToPublish: any = [];
  // second variable is to get filtered shifts ie exclude shifts which have been published before
  shiftsToPublishListFiltered: any = [];
  publishedHistoryData: any = {};

  conflictData: any;
  shiftStatsByAssignee: any = {};
  shiftStatsBySite: any = {};
  shiftStatsByDate: any = {};

  weekCopiedShifts: any = [];
  removeAssigneeWhileCopying: boolean = false;

  isAdminUser = this.dataCheckService.isUserAdmin();
  isDispatcherUser: boolean = false;
  currentUserData = {
    id: '',
    full_name: '',
  };
  userListFilterId: string = '';

  isCopyingWeek = false;
  isEnteringNewWeek = false;

  fetchingData = false;

  subContractorAssigneeMap = new Map();

  userLeaveData: any = {};

  shiftFilterData: any = { selectedSites: [], selectedUsers: [] };

  jobShiftOnsiteOffsiteInfo: any = {};

  todayInMs = new Date().setHours(0, 0, 0, 0);

  constructor(
    private jobService: JobsService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private dataCheckService: DataCheckService,
    private router: Router,
    private dialogService: ModalDialogueService,
    private appService: AppService,
    private rsService: RosterShiftsService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private clientService: ClientsService,
    private rosterService: RosterService,
    private userService: UsersService,
  ) {}

  ngOnDestroy(): void {
    window.onpopstate = null;

    this.shiftApiCallSubject.next();
    this.shiftApiCallSubject.complete();

    if (this.shiftSubscription) {
      this.shiftSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    // this.nextSetPatrolRunsheetSubject.next();
    // this.nextSetPatrolRunsheetSubject.complete();
  }
  ngOnInit(): void {
    const userData = this.appService.getUserData();
    const subUserId = userData?.subscriber?.subscriber_user_id;
    this.currentUserData = {
      id: subUserId,
      full_name: 'You',
    };
    this.getWeatherInfo();

    let _filter: any =
      sessionStorage.getItem(btoa('scheduleFilters')) ||
      this.route.snapshot.queryParamMap.get('gt');
    if (_filter) {
      _filter = JSON.parse(atob(_filter) || '{}');

      this.selectedClient = _filter?.selectedClient?.id
        ? _filter?.selectedClient
        : {};
      this.selectedJobType = _filter?.selectedJobType?.id
        ? _filter?.selectedJobType
        : {};
      this.shiftFilterData = _filter?.selectedJobType?.id
        ? _filter?.shiftFilterData
        : { selectedSites: [], selectedUsers: [] };
      this.shiftDataGroupBy = _filter?.shiftDataGroupBy || 'person';
      this.userListFilterId = _filter?.userListFilterId || '';
    }

    if (this.route.snapshot.fragment) {
      const day = new Date(this.route.snapshot.fragment);

      if (this.largeView) {
        this.getMonday(day);
      } else {
        this.generateWeekDays(day);
      }
    } else {
      if (this.largeView) {
        this.getMonday();
      } else {
        this.generateWeekDays(new Date());
      }
    }

    this.searchClients('');
    if (this.selectedJobType?.id) {
      this.isDispatcherUser = this.dataCheckService.isDispatchUser({
        permission: 'job_type',
        action: 'add',
        id: this.selectedJobType?.id,
      });
    }

    this.getAllPossibleJobTypes();
    if (this.shiftDataGroupBy == 'site') {
      this.getSiteList();
    }
    this.getUserListData();

    this.resetAndCallLeaveList();
  }
  getAllPossibleJobTypes() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );

    this.jobService.getJobParams().subscribe((response: any) => {
      this.getShiftStylingDict(response?.statuses || []);
      const filteredJobTypes = (response?.data || [])?.filter(
        (_type: any) =>
          ![0, 5].includes(_type?.type_identity) &&
          (_type?.type_identity === 4
            ? subscriberStats.checkpoint_count > 0
            : true),
      );
      this.availableJobTypes = filteredJobTypes;
      if (!this.selectedJobType?.id)
        this.selectedJobType = this.availableJobTypes?.find(
          (jType: any) => jType?.type_identity == 6, // by default select scheduled patrol
        );
    });
  }
  getShiftStylingDict(statusListData: any) {
    //  this.jobStatusDataList = response.statuses;
    // get only job types with roster

    statusListData.push({
      id: '0',
      name: 'Closed',
      additional_info: {
        style: {
          snubbed: {
            'color': 'var(--color-basic-1100)',
            'background-color': 'var(--color-basic-100)',
            'border': '1px solid var(--color-basic-1100)',
            'border-radius': '5px',
            'font-size': 'smaller',
            'padding-left': '1rem',
            'padding-right': '1rem',
            'text-align': 'center',
          },
        },
      },
    });
  }
  async onUserListFilter(event: any) {
    this.userListFilterId = event.target.value;
    this.updateSessionStorage();

    this.updateRosterMap();
  }
  async onSelectJobType(event: any) {
    const continueDrafting = await this.continueDrafting();
    if (continueDrafting) return;
    this.deselectShift();
    this.selectedGlobalAction = '';
    this.selectedJobType = this.availableJobTypes?.find(
      (jType: any) => jType?.id == event?.target?.value,
    );

    // this.userListFilterId = sessionStorage'';
    if (!this.selectedJobType?.id) return;
    this.shiftApiCallSubject.next();
    if (this.shiftSubscription) {
      this.shiftSubscription.unsubscribe();
    }
    this.shiftFilterData = { selectedSites: [], selectedUsers: [] };
    const savedUserFilterIdDict = JSON.parse(
      localStorage.getItem(btoa('savedUserFilterIdDict')) || '{}',
    );
    this.userListFilterId =
      savedUserFilterIdDict?.[this.selectedJobType?.id] || '';

    this.isDispatcherUser = this.dataCheckService.isDispatchUser({
      permission: 'job_type',
      action: 'add',
      id: this.selectedJobType?.id,
    });
    if (
      ![6, 4].includes(this.selectedJobType?.type_identity) &&
      !this.selectedClient?.id
    ) {
      this.selectedClient = { id: 1, company_name: 'All Shifts' };
      if (this.shiftDataGroupBy == 'person') this.changeShiftGroupBy('site');
    }

    if (
      [6, 4].includes(this.selectedJobType?.type_identity) ||
      this.selectedClient?.id
    ) {
      if ([6, 4].includes(this.selectedJobType?.type_identity)) {
        this.selectedClient = {};
        if (this.shiftDataGroupBy == 'site') this.changeShiftGroupBy('person');
      }
      this.getShiftData();
    } else {
      this.rosterDataList = [];
      this.rosterGridMap = {};
    }
  }

  getMonday(date: Date = new Date()) {
    const monday = new Date(date);
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    this.generateWeekDays(monday);
  }
  getOnlyDateFromDateTime(date?: any) {
    const updateDate = date ? new Date(date) : new Date();
    updateDate.setHours(0, 0, 0, 0);
    return updateDate;
  }

  generateWeekDays(date: Date) {
    const days: Date[] = [];
    const mondayoftheweek = this.getOnlyDateFromDateTime(date);
    this.selectedSearchDate = getFormattedDate(mondayoftheweek);
    if (this.largeView) {
      const today = this.getOnlyDateFromDateTime();

      this.isCurrentWeek = false;

      for (let i = 0; i < 7; i++) {
        const nextDay = new Date(mondayoftheweek);
        nextDay.setDate(mondayoftheweek.getDate() + i);

        if (!this.isCurrentWeek) {
          this.isCurrentWeek = today.getTime() === nextDay.getTime();
        }

        days.push(nextDay);
      }
    } else {
      days.push(new Date(this.selectedSearchDate));
    }

    this.weekDays = days;

    this.isPastWeek = this.isPastScheduleCheck(days[days?.length - 1]);

    this.getShiftData();
  }
  getShiftTypeString(): 'runsheet' | 'patrol' | 'job' {
    return this.selectedJobType?.type_identity == 6 || !this.selectedJobType?.id
      ? 'runsheet'
      : this.selectedJobType?.type_identity == 4
        ? 'patrol'
        : 'job';
  }
  async continueDrafting() {
    const hasDraftedChanges =
      this.dataBackupDict.idsToBeDeleted?.size ||
      this.dataBackupDict.draftedChanges?.length;

    if (!hasDraftedChanges) {
      return false;
    }
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Discard Changes?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Ok', class: 'btn-primary' },
      },
    });
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());

    return !dialogResponse;
  }
  getShiftData() {
    this.rosterDataList = [];
    this.rosterGridMap = {};

    this.shiftsToPublish = [];
    this.shiftsToPublishListFiltered = [];
    this.publishedHistoryData = {};
    this.fetchingData = true;

    this.getShiftDataForWeek();
  }

  async onDateSelect(type: 'week' | 'day' | 'search', action: '+' | '-' | '=') {
    const continueDrafting = await this.continueDrafting();
    if (continueDrafting) return;
    if (!this.selectedGlobalAction) this.deselectShift();
    if (type == 'week') {
      if (action == '=') {
        this.getMonday();
      } else {
        const newDate = new Date(this.selectedSearchDate);
        newDate.setDate(newDate.getDate() + (action === '+' ? 7 : -7));
        this.generateWeekDays(newDate);
      }
    } else if (type == 'day') {
      if (action == '=') {
        const selectedDate = new Date();
        this.generateWeekDays(selectedDate);
      } else {
        const newDate = new Date(this.selectedSearchDate);
        newDate.setDate(newDate.getDate() + (action === '+' ? 1 : -1));
        this.generateWeekDays(newDate);
      }
    } else {
      if (action == '=') {
        const selectedDate = this.selectedSearchDate
          ? new Date(this.selectedSearchDate)
          : new Date();
        if (this.largeView) {
          this.getMonday(selectedDate);
        } else {
          this.generateWeekDays(selectedDate);
        }
      }
    }
    this.resetAndCallLeaveList();
  }

  getUserListData(nextCursor?: string) {
    if (!(this.isAdminUser || this.isDispatcherUser)) return;
    let params: any = { rows: 20, get_user_tags: 1 };

    if (nextCursor) params.next_cursor = nextCursor;
    this.jobService.getUserList(params).subscribe(async (response: any) => {
      if (response?.status != 'success') return;

      this.userListData = [...this.userListData, ...(response?.data || [])];
      if (response?.next_cursor) {
        this.getUserListData(response?.next_cursor);
      } else {
        this.userLookupListData = JSON.parse(
          JSON.stringify(this.userListData),
        )?.slice(0, 10);
        this.subContractorAssigneeMap = new Map<number, any>(
          this.userListData.map((user: any) => [
            user?.id,
            user?.subcontractors,
          ]),
        );
      }
      this.getUpdatedFilteredRosterList();
    });
  }

  async getSitesFromServer(previous = 0) {
    const rowSize = 20;
    let params: any = {
      company: this.selectedClient?.id,
      rows: rowSize,
    };
    if (previous) params.previous = previous;
    const response: any = await firstValueFrom(
      this.clientService.getSiteList(params),
    );
    if (response?.status == 'success') {
      const existingSiteIds = new Set(
        this.siteListData?.map((item: any) => item?.id),
      );

      this.siteListData = [
        ...this.siteListData,
        ...response?.data?.filter(
          (item: any) => !existingSiteIds?.has(item?.id),
        ),
      ];
      sortArrayOfObject(this.siteListData, 'company_name', 'asc');

      if (this.siteListData?.length < response?.total_size) {
        this.getSitesFromServer(previous + rowSize);
      } else {
        this.siteLookupListData = JSON.parse(
          JSON.stringify(this.siteListData),
        )?.slice(0, 10);
      }
    }
  }
  async getSiteList() {
    if (
      !this.selectedClient?.id ||
      this.selectedClient?.id == 'undefined' ||
      this.selectedClient?.id == 1
    )
      return;
    try {
      const record: any = await gTDB.cachedData
        .where('shortPath')
        .equals('/api/site/list_all_sites/')
        .first();
      const rawData: any[] = record?.data || [];
      if (this.selectedClient?.id && this.selectedClient?.id !== 1) {
        this.siteListData = rawData?.filter(
          (site: any) => site?.company?.id == this.selectedClient?.id,
        );
      } else {
        this.siteListData = rawData;
      }

      sortArrayOfObject(this.siteListData, 'company_name', 'asc');
      this.siteLookupListData = JSON.parse(
        JSON.stringify(this.siteListData),
      )?.slice(0, 10);
    } catch (error) {}

    this.getSitesFromServer();
  }
  changeShiftGroupBy(shiftGroupBy: 'person' | 'site') {
    switch (shiftGroupBy) {
      case 'site':
        if (!this.selectedClient?.id) {
          this.toasterService.setMessage({ errorMessage: 'Select a client' });
          return;
        }
        if (!this.siteListData?.length) this.getSiteList();
        break;
    }
    this.shiftDataGroupBy = shiftGroupBy;
    this.updateRosterMap();
  }
  getCellKey(uniqueId: string | number, date: Date): string {
    return getScheduleCellKey(uniqueId, date);
  }

  isFutureDayPredicate = (eventDate: any) => {
    return (drag: CdkDrag<any>, drop: CdkDropList<any>): boolean => {
      if (!eventDate) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const targetDay = new Date(eventDate);
      targetDay.setHours(0, 0, 0, 0);

      return targetDay.getTime() >= today.getTime();
    };
  };
  getCellKeyForShift(shift: any) {
    const uniqueId =
      (this.shiftDataGroupBy === 'site'
        ? shift?.site_id
        : shift?.assignee_id) || 0;

    const d = new Date(shift?.event_date);
    d.setHours(0, 0, 0, 0);

    return `${uniqueId}_${d.getTime()}`;
  }

  getDraggedNCopiedChanges(action: 'drag' | 'copy' = 'drag') {
    const gobalDeletedIds = new Set();
    const dataList = JSON.parse(JSON.stringify(this.rosterDataList));
    this.updateRosterMap();

    const currentIdsByCellKey = new Map<string, Set<number>>();
    const otherDraftedChanges: any = [];
    dataList?.forEach((shift: any) => {
      const key = this.getCellKeyForShift(shift);

      if (!currentIdsByCellKey.has(key)) {
        currentIdsByCellKey.set(key, new Set());
      }

      if (shift?.id) {
        currentIdsByCellKey.get(key)!.add(shift.id);
        if (shift?.draftedItem) {
          otherDraftedChanges.push({
            ...shift,
            id: null,
            shiftUniqueId: shift?.id,
          });
        }
      }
    });

    if (action == 'drag') {
      Object.entries(this.dataBackupDict?.idEventDateDict || {}).forEach(
        ([key, existingSet]: [string, any]) => {
          const currentSet = currentIdsByCellKey.get(key) || new Set<number>();

          existingSet.forEach((id: any) => {
            if (!currentSet.has(id)) {
              gobalDeletedIds.add(id);
            }
          });
        },
      );
      this.dataBackupDict.idsToBeDeleted = gobalDeletedIds;
    }
    this.dataBackupDict.draftedChanges = otherDraftedChanges;
  }

  async onDeleteShift(shiftData: any) {
    this.rosterDataList = this.rosterDataList?.filter(
      (shift: any) => shiftData?.id != shift?.id,
    );

    this.getDraggedNCopiedChanges('drag');
    this.selectedShift = {};
    return;

    // const dialogRef = this.dialogService.open(
    //   template,
    //   {
    //     data: shiftData,
    //   },
    //   this.viewContainerRef,
    // );
    // const dResponse = await firstValueFrom(dialogRef.afterClosed());
    // if (dResponse?.id) {
    //   if (shiftData?.repeat_type == 'once') this.shiftRecurranceSelection = 1;
    //   switch (this.selectedJobType?.type_identity) {
    //     case 6: // runsheet
    //       let params: any = { delete_run_sheet: 1 };
    //       if (this.shiftRecurranceSelection == 2) params.delete_shift = 1;
    //       this.spinnerService.show('Removing Shifts');
    //       this.runSheetService
    //         .updateRunSheet(
    //           dResponse?.id,
    //           { event_date: dResponse?.event_date },
    //           params,
    //         )
    //         .then((response: any) => {
    //           if (response?.status === 'success') {
    //             this.selectedShift = {};
    //             this.getShiftData();
    //           } else {
    //             this.spinnerService.hide();
    //             this.toasterService.setMessage({
    //               successMessage: '',
    //               errorMessage: response?.message,
    //             });
    //           }
    //         });
    //       break;
    //     default:
    //       let reqBody: any = {};
    //       let reqParams: any = {};
    //       this.spinnerService.show('Removing Shifts');
    //       if (this.selectedJobType?.type_identity === 4) {
    //         //patrol jobs
    //         reqBody = { ...reqBody };
    //         reqParams = {
    //           ...reqParams,
    //           patrol_job: 1,
    //           delete_job: 1,
    //           future_jobs_also: this.shiftRecurranceSelection == 2 ? 1 : 0,
    //         };
    //       } else {
    //         reqBody = { ...reqBody };
    //         reqParams = {
    //           ...reqParams,
    //           delete_job: 1,
    //           future_jobs_also: this.shiftRecurranceSelection == 2 ? 1 : 0,
    //         };
    //       }
    //       this.rsService
    //         .updateRosterShifts(shiftData?.id, reqBody, reqParams)
    //         .then((response: any) => {
    //           if (response?.status === 'success') {
    //             this.selectedShift = {};
    //             setTimeout(() => {
    //               this.getShiftData();
    //             }, 1000);
    //           } else {
    //             this.spinnerService.hide();
    //             this.toasterService.setMessage({
    //               errorMessage: response?.message,
    //               successMessage: '',
    //             });
    //           }
    //         });

    //       break;
    //   }
    // }
  }

  onRedirectShift(shiftData: any) {
    switch (this.selectedJobType?.type_identity) {
      case 6: // runsheet
        this.router.navigate([
          '/view-runsheet',
          { rKey: String(shiftData?.id) },
        ]);
        break;
      case 4:
        this.router.navigate([
          '/view-route',
          {
            rKey: String(shiftData?.id),
          },
        ]);
        break;
      default:
        this.router.navigate([`/job-detail/JOBID`], {
          queryParams: { jId: shiftData?.id },
        });
        break;
    }
  }

  getStartEndDays() {
    const startDay = new Date(this.selectedSearchDate);
    startDay.setHours(0, 0, 0, 0);
    const endDay = new Date(startDay);
    endDay.setDate(endDay.getDate() + (this.largeView ? 6 : 0));
    return {
      start_day: formatDate(startDay, 'yyyy-MM-dd', 'en_US'),
      end_day: formatDate(endDay, 'yyyy-MM-dd', 'en_US'),
    };
  }
  getUpdatedFilteredRosterList() {
    let dataList = JSON.parse(JSON.stringify(this.rosterDataList || []));
    let filteredShiftResult = [];
    if (
      this.shiftFilterData?.selectedSites?.length &&
      ![6, 4].includes(this.selectedJobType?.type_identity)
    ) {
      const siteIds = new Set(
        this.shiftFilterData?.selectedSites?.map((item: any) => item?.id),
      );
      dataList = dataList?.filter((item: any) => siteIds?.has(item?.site_id));
    }
    if (this.shiftFilterData?.selectedUsers?.length) {
      const assigneeIds = new Set(
        this.shiftFilterData?.selectedUsers?.map((item: any) => item?.id),
      );
      dataList = dataList?.filter((item: any) =>
        assigneeIds?.has(item?.assignee_id),
      );
    }

    if (this.userListFilterId) {
      const filteredUsers = this.userListData
        ?.filter(
          (user: any) =>
            (user?.user_list?.tag_ids || [])?.includes(this.userListFilterId) ||
            (user?.user_list?.job_type_ids || [])?.includes(
              this.userListFilterId,
            ),
        )
        ?.map((user: any) => user?.id);

      if (filteredUsers?.length) {
        filteredShiftResult = dataList?.filter((shift: any) =>
          filteredUsers?.includes(shift?.assignee_id),
        );
      } else {
        filteredShiftResult = [];
      }
    } else {
      filteredShiftResult = dataList;
    }
    this.filteredRosteredList = filteredShiftResult;
    this.filteredRosteredDataStat = {
      count: filteredShiftResult?.length,
      shiftsToClear: filteredShiftResult?.some((shift: any) =>
        this.isFutureScheduleCheck(shift?.event_date),
      ),

      assigned: filteredShiftResult?.reduce((sum: number, shift: any) => {
        return sum + (shift?.assignee_id ? 1 : 0);
      }, 0),
    };
  }

  getShiftDataForWeek(nextCursor?: any) {
    let params: any = {
      rows: 15,
      ...this.getStartEndDays(),
      shift_type: this.getShiftTypeString(),
    };

    if (
      this.selectedJobType?.id &&
      ![6, 4].includes(this.selectedJobType?.type_identity)
    ) {
      // on first load this.selectedJobType?.id may not have a value
      if (!this.selectedClient?.id || this.selectedClient?.id == 'undefined') {
        this.fetchingData = false;
        return;
      }

      if (this.selectedClient?.id != 1)
        params['company_id'] = this.selectedClient?.id;
      params['job_type_id'] = this.selectedJobType?.id;
    }

    if (nextCursor) {
      params['next_cursor'] = nextCursor;
    }
    if (this.updatedShiftIds?.length) {
      params['shift_id'] = this.updatedShiftIds[0];
    }
    if (this.weekCopiedShifts?.length) {
      this.weekCopiedShifts.forEach((shift: any) => {
        const updatedDate = new Date(shift?.event_date);
        updatedDate.setDate(updatedDate.getDate() + 7);

        const updatedItem: any = {
          ...shift,
          event_date: formatDate(updatedDate, 'yyyy-MM-dd', 'en_US'),
          draftedItem: true,
          id: uuidv4(),
          copied: true,
          orginal_id: shift?.id,
          status_dict: {},
        };
        if (this.removeAssigneeWhileCopying) {
          updatedItem.assignee_id = '';
          updatedItem.assignee_name = '';
        }

        this.rosterDataList.push(updatedItem);
      });
      this.updateSiteListForAllShifts();
      this.removeAssigneeWhileCopying = false;
      this.weekCopiedShifts = [];
    }
    // Cancel any lingering subscription handle just to be safe
    if ((!nextCursor || nextCursor === null) && this.shiftSubscription) {
      this.shiftSubscription.unsubscribe();
    }

    this.shiftSubscription = this.rosterService
      .getShifts(params)
      .pipe(takeUntil(this.shiftApiCallSubject))
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          if (this.updatedShiftIds?.length) {
            // special case where only one shift is updated; no need to refresh the whole weeks
            const updatedShift = response?.data?.[0];
            this.updatedShiftIds = [];
            if (updatedShift?.id) {
              const index = this.rosterDataList?.findIndex(
                (item: any) => item?.id == updatedShift?.id,
              );
              if (index > -1) {
                this.rosterDataList[index] = { ...updatedShift };
              } else {
                this.rosterDataList.push(updatedShift);
              }
              this.rosterDataList = [...this.rosterDataList];

              this.updateSiteListForAllShifts();

              this.updateRosterMap();
              this.spinnerService.hide();
            }
            return;
          }

          const responseData = response?.data;
          const existingIds = new Set(
            this.rosterDataList?.map((item: any) => item?.id),
          );

          if ([2].includes(this.selectedJobType?.type_identity)) {
            const pastShifts = responseData?.filter(
              (item: any) => !this.isFutureScheduleCheck(item?.event_date),
            );

            this.getOnsiteOffsiteInfoForJobs(
              pastShifts?.map((item: any) => item?.id),
            );
          }

          this.rosterDataList = [
            ...this.rosterDataList,
            ...responseData?.filter((item: any) => !existingIds?.has(item?.id)),
          ];
          this.updateSiteListForAllShifts();

          this.updateRosterMap();
          this.spinnerService.hide();
          if (response?.next_cursor) {
            this.getShiftDataForWeek(response?.next_cursor);
          } else {
            this.fetchingData = false;
            this.getPublishedHistory();
            const dataList = JSON.parse(
              JSON.stringify(
                this.rosterDataList?.filter((item: any) => !item?.draftedItem),
              ),
            );

            const idEventDateDict: any = {};
            dataList?.forEach((shift: any) => {
              const key = this.getCellKeyForShift(shift);

              if (key in idEventDateDict) {
                idEventDateDict[key].add(shift?.id);
              } else {
                idEventDateDict[key] = new Set([shift?.id]);
              }
            });

            this.dataBackupDict = {
              data: dataList,
              idEventDateDict: idEventDateDict,
            };
            this.getDraggedNCopiedChanges('copy');
            this.router.navigate(['/schedule'], {
              fragment: this.selectedSearchDate,
              queryParams: {
                // gt: btoa(
                //   JSON.stringify({
                //     selectedClient: this.selectedClient || {},
                //     selectedJobType: this.selectedJobType || {},
                //     shiftDataGroupBy: this.shiftDataGroupBy || 'person',
                //     userListFilterId: this.userListFilterId || '',
                //   }),
                // ),
              },
              replaceUrl: true, // Replaces the current URL without adding a new history entry
            });
            this.updateSessionStorage();
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  updateSessionStorage() {
    if (this.selectedJobType?.id) {
      let savedUserFilterIdDict = JSON.parse(
        localStorage.getItem(btoa('savedUserFilterIdDict')) || '{}',
      );
      savedUserFilterIdDict = { ...(savedUserFilterIdDict || {}) };
      savedUserFilterIdDict[this.selectedJobType?.id] =
        this.userListFilterId || '';
      localStorage.setItem(
        btoa('savedUserFilterIdDict'),
        JSON.stringify(savedUserFilterIdDict),
      );
    }

    sessionStorage.setItem(
      btoa('scheduleFilters'),
      btoa(
        JSON.stringify({
          selectedClient: this.selectedClient || {},
          selectedJobType: this.selectedJobType || {},
          shiftFilterData: this.shiftFilterData || {
            selectedSites: [],
            selectedUsers: [],
          },
          shiftDataGroupBy: this.shiftDataGroupBy || 'person',
          userListFilterId: this.userListFilterId || '',
        }),
      ),
    );
  }
  getStartAndEndDateTime(shift: any) {
    const startDateTime = new Date(shift?.event_date + ' ' + shift?.start_time);

    const endDateTime = new Date(shift?.event_date + ' ' + shift?.end_time);
    if (shift?.end_time < shift?.start_time) {
      // overnight schedule
      endDateTime.setDate(endDateTime.getDate() + 1);
    }
    return [startDateTime.getTime(), endDateTime.getTime()];
  }
  updateSiteListForAllShifts() {
    if (this.selectedClient?.id != 1) return;
    const siteListData = Array.from(
      new Map(
        this.rosterDataList.map((item: any) => [item?.site_id, item]),
      ).values(),
    ).map((shift: any) => ({
      id: shift?.site_id,
      company_name: shift?.site_name,
      company: {
        id: shift?.company_id,
        company_name: shift?.company_name,
      },
    }));
    siteListData.sort(
      (a, b) =>
        a?.company?.company_name.localeCompare(b?.company?.company_name) ||
        a?.company_name.localeCompare(b?.company_name),
    );

    this.siteListData = [...siteListData];
  }
  updateRosterMap() {
    const newMap: Record<string, any[]> = {};
    const shiftsByAssignee: Record<string, any[]> = {};
    const shiftStatsByAssignee: Record<string, any> = {};
    const shiftStatsBySite: Record<string, any> = {};
    const shiftStatsByDate: Record<string, any> = {};

    this.getUpdatedFilteredRosterList();
    this.checkAndFilterShiftsToPublish();

    const shifts: any[] = JSON.parse(
      JSON.stringify(this.filteredRosteredList || []),
    );

    for (const shift of shifts || []) {
      if (!shift?.event_date) continue;

      const key = this.getCellKeyForShift(shift);

      if (!newMap[key]) {
        newMap[key] = [];
      }
      newMap[key].push(shift);
      const aid = shift?.assignee_id;
      const [start, end] = this.getStartAndEndDateTime(shift);
      if (aid) {
        if (!shiftsByAssignee[aid]) shiftsByAssignee[aid] = [];

        const updatedShift = { ...shift, start, end };
        if (![2, 3].includes(shift?.status_dict?.identity))
          shiftsByAssignee[aid].push(updatedShift);

        if (!shiftStatsByAssignee[aid])
          shiftStatsByAssignee[aid] = { hours: 0, shifts: 0 };
        shiftStatsByAssignee[aid]['hours'] += end - start;
        shiftStatsByAssignee[aid]['shifts'] += 1;
      }

      const shiftSiteId = shift?.site_id;
      if (shiftSiteId) {
        if (!shiftStatsBySite[shiftSiteId])
          shiftStatsBySite[shiftSiteId] = { hours: 0, shifts: 0 };
        shiftStatsBySite[shiftSiteId]['hours'] += end - start;
        shiftStatsBySite[shiftSiteId]['shifts'] += 1;
      }
      if (!shiftStatsByDate[shift?.event_date])
        shiftStatsByDate[shift?.event_date] = { hours: 0, shifts: 0 };
      shiftStatsByDate[shift?.event_date]['hours'] += end - start;
      shiftStatsByDate[shift?.event_date]['shifts'] += 1;
    }
    for (const key in newMap) {
      if (newMap.hasOwnProperty(key)) {
        newMap[key].sort((a, b) => {
          const timeA = a?.start_time || '';
          const timeB = b?.start_time || '';

          return timeA.localeCompare(timeB);
        });
      }
    }
    this.shiftStatsByAssignee = { ...shiftStatsByAssignee };
    this.shiftStatsBySite = { ...shiftStatsBySite };
    this.shiftStatsByDate = { ...shiftStatsByDate };
    this.conflictData = {};
    for (const [aid, jobList] of Object.entries(shiftsByAssignee)) {
      // Sort by start time
      const sorted = [...jobList].sort(
        (a, b) => (a?.start || 0) - (b?.start || 0),
      );
      const clusters: any[][] = [];
      let currentCluster: any[] = [];
      let clusterEnd = 0;

      for (const job of sorted) {
        if (currentCluster.length === 0) {
          currentCluster.push(job);
          clusterEnd = job?.end || 0;
        } else if (job?.start < clusterEnd) {
          // Overlaps with the current active cluster window
          currentCluster.push(job);
          clusterEnd = Math.max(clusterEnd, job?.end || 0);
        } else {
          // No overlap; close the old cluster and start a new one
          if (currentCluster.length > 1) {
            clusters.push(currentCluster);
          }
          currentCluster = [job];
          clusterEnd = job?.end || 0;
        }
      }

      // Push the final cluster if it contains overlapping jobs
      if (currentCluster.length > 1) {
        clusters.push(currentCluster);
      }

      // Save conflicts

      for (const cluster of clusters) {
        const eventDateKey = formatDate(
          new Date(cluster[0].start),
          'yyyy-MM-dd',
          'en_US',
        );

        if (!this.conflictData[eventDateKey])
          this.conflictData[eventDateKey] = {};
        this.conflictData[eventDateKey][aid] = {
          jobs: cluster,
          assigneeInfo: {
            id: cluster[0]?.assignee_id,
            full_name: cluster[0]?.assignee_name,
          },
        };
      }
    }

    this.rosterGridMap = newMap;
  }
  async onClientSelect(clientData: any) {
    const continueDrafting = await this.continueDrafting();
    if (continueDrafting) return;
    if (clientData?.key == 0) {
      this.selectedClient = { id: 1, company_name: 'All Shifts' }; // This is a hack
    } else {
      this.selectedClient = clientData;
    }

    this.siteListData = [];
    this.siteLookupListData = [];
    this.getSiteList();
    if (this.shiftDataGroupBy == 'person') this.changeShiftGroupBy('site');

    this.getShiftData();
  }

  onClientSearch(event: any) {
    this.searchClients(event.target.value);
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.clientDropDownBackupList = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  editField(field: string) {
    this.selectedClient = {};

    if (field == 'client') {
      this.shiftFocus('scheduleClientLookupFieldId');
      this.clientDropDownList = JSON.parse(
        JSON.stringify(this.clientDropDownBackupList || []),
      );
    }
  }
  onResetChanges() {
    this.rosterDataList = JSON.parse(
      JSON.stringify(this.dataBackupDict?.data || []),
    );
    this.selectedGlobalAction = '';
    this.getDraggedNCopiedChanges();
  }
  onSaveChanges() {
    // this.onUpdateShift();
    if (!(
      this.dataBackupDict.idsToBeDeleted?.size ||
      this.dataBackupDict.draftedChanges?.length
    ))
      return;
    // this.spinnerService.show('Saving Changes');
    this.rosterService
      .saveModifyShifts(
        {
          group_by: this.shiftDataGroupBy,
          drafted_changes: this.dataBackupDict?.draftedChanges || [],
          ids_to_be_deleted: this.dataBackupDict?.draftedChanges?.length
            ? []
            : [...(this.dataBackupDict?.idsToBeDeleted || [])],
        },
        { shift_type: this.getShiftTypeString(), ...this.getStartEndDays() },
      )
      .then((response: any) => {
        if (response?.status !== 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({ errorMessage: response?.message });
          return;
        }
        this.selectedGlobalAction = '';
        this.deselectShift();
        // this.spinnerService.show('Fetching Data');
        this.getShiftData();
      });
  }
  deselectShift() {
    this.selectedShift = null;
    this.selectedShiftBackup = null;
  }
  onCellClick(uniqueRow: any, date: Date) {
    if (!['move', 'copy'].includes(this.selectedGlobalAction)) return;

    if (this.selectedGlobalAction == 'copy') {
      const updatedItem: any = {
        ...this.selectedShift,
        event_date: formatDate(date, 'yyyy-MM-dd', 'en_US'),
        draftedItem: true,
        id: uuidv4(),
        copied: true,
        orginal_id: this.selectedShift?.id,
        acceptance_status: 3,
      };
      if (this.shiftDataGroupBy === 'site') {
        updatedItem['site_id'] = uniqueRow?.id;
        updatedItem['site_name'] = uniqueRow?.company_name;
      } else {
        updatedItem['assignee_id'] = uniqueRow?.id;
        updatedItem['assignee_name'] = uniqueRow?.full_name;
      }

      this.rosterDataList = [...this.rosterDataList, updatedItem];
      this.getDraggedNCopiedChanges('copy');
    } else {
      const draggedItem = this.selectedShift;
      const updatedItem: any = {
        ...draggedItem,
        event_date: formatDate(date, 'yyyy-MM-dd', 'en_US'),
        draftedItem: false,
        orginal_id: draggedItem?.orginal_id || draggedItem?.id,
      };
      if (this.shiftDataGroupBy === 'site') {
        updatedItem['site_id'] = uniqueRow?.id;
        updatedItem['site_name'] = uniqueRow?.company_name;
      } else {
        updatedItem['assignee_id'] = uniqueRow?.id;
        updatedItem['assignee_name'] = uniqueRow?.full_name;
      }

      const filteredRunsheetShifts = this.rosterDataList.filter(
        (item: any) => item?.id !== draggedItem?.id,
      );

      if (
        draggedItem?.event_date_backup !== updatedItem?.event_date ||
        draggedItem?.assignee_id_backup !== updatedItem?.assignee_id ||
        (draggedItem?.site_id_backup &&
          draggedItem?.site_id_backup !== updatedItem?.site_id)
      ) {
        // item has changed
        updatedItem.draftedItem = true;
      }

      this.rosterDataList = [...filteredRunsheetShifts, updatedItem];

      this.getDraggedNCopiedChanges();
    }
    this.selectedShiftBackup = null;
  }

  onDrop(event: CdkDragDrop<any>, targetRow: any, targetDate: Date) {
    this.deselectShift();
    const draggedItem = event.item.data as any;
    const updatedItem: any = {
      ...draggedItem,
      event_date: formatDate(targetDate, 'yyyy-MM-dd', 'en_US'),
      draftedItem: false,
      orginal_id: draggedItem?.orginal_id || draggedItem?.id,
    };

    if (this.shiftDataGroupBy === 'site') {
      updatedItem['site_id'] = targetRow?.id;
      updatedItem['site_name'] = targetRow?.company_name;
    } else {
      updatedItem['assignee_id'] = targetRow?.id;
      updatedItem['assignee_name'] = targetRow?.full_name;
    }

    const filteredRunsheetShifts = this.rosterDataList.filter(
      (item: any) => item?.id !== draggedItem?.id,
    );

    if (
      draggedItem?.event_date_backup !== updatedItem?.event_date ||
      draggedItem?.assignee_id_backup !== updatedItem?.assignee_id ||
      (draggedItem?.site_id_backup &&
        draggedItem?.site_id_backup !== updatedItem?.site_id)
    ) {
      // item has changed
      updatedItem.draftedItem = true;
    }

    this.rosterDataList = [...filteredRunsheetShifts, updatedItem];

    this.getDraggedNCopiedChanges();
  }
  async onModifyShift(template: any, row?: any, day?: any) {
    if (this.selectedClient?.id) {
      if (this.selectedClient?.id == 1) {
        this.onSiteSearch('');
      } else if (!this.siteListData?.length) {
        this.getSiteList();
      }
    }

    const editingShift = !day && this.selectedShift?.id;

    const d = new Date(day);
    d.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const [selectedShiftStart, selectedShiftEnd] = this.getStartAndEndDateTime(
      this.selectedShift,
    );

    let shiftStart = editingShift ? new Date(selectedShiftStart) : new Date();
    let shiftEnd = editingShift ? new Date(selectedShiftEnd) : new Date();

    const startDay = editingShift
      ? new Date(selectedShiftStart)
      : new Date(day);
    let endDay = editingShift ? new Date(selectedShiftEnd) : new Date(day);

    const scheduleLastSavedTimes = JSON.parse(
      sessionStorage.getItem(btoa('scheduleLastSavedTimes')) || '{}',
    );

    if (
      scheduleLastSavedTimes?.start_time &&
      scheduleLastSavedTimes?.end_time
    ) {
      const [startHours, startMinutes] =
        scheduleLastSavedTimes.start_time.split(':');
      const [endHours, endMinutes] = scheduleLastSavedTimes.end_time.split(':');

      shiftStart.setHours(Number(startHours), Number(startMinutes), 0, 0);

      shiftEnd.setHours(Number(endHours), Number(endMinutes), 0, 0);

      if (shiftEnd < shiftStart) {
        shiftEnd.setDate(shiftEnd.getDate() + 1);
      }
    } else {
      const isToday = d.toDateString() === today.toDateString();

      if (isToday) {
        [shiftStart, shiftEnd] = getStartAndEndTime(new Date());
      } else {
        shiftStart.setHours(6, 0, 0, 0);
        shiftEnd.setTime(shiftStart.getTime());
        shiftEnd.setHours(shiftEnd.getHours() + 12, 0, 0, 0);
      }
    }

    if (shiftEnd.toDateString() !== shiftStart.toDateString()) {
      endDay.setDate(endDay.getDate() + 1);
    }

    let shiftData: any = {};

    if (editingShift) {
      shiftData = { ...this.selectedShift };
    } else {
      shiftData = {
        start_time: getFormattedTime(shiftStart),
        end_time: getFormattedTime(shiftEnd),
        shift_duration: getTimerValueDuration(shiftStart, shiftEnd),
        event_date: formatDate(day, 'yyyy-MM-dd', 'en_US'),
        draftedItem: true,
        id: uuidv4(),
      };

      if (this.shiftDataGroupBy == 'person') {
        shiftData['assignee_id'] = row?.id;
        shiftData['assignee_name'] = row?.full_name;
      } else {
        shiftData['site_id'] = row?.id;
        shiftData['site_name'] = row?.company_name;
        shiftData['assignee_id'] = 0;
        shiftData['assignee_name'] = 'Unassigned';
      }
      if (
        ![6, 4].includes(this.selectedJobType?.type_identity) &&
        this.selectedClient?.id
      ) {
        shiftData['job_type_id'] = this.selectedJobType?.id;
        shiftData['company_id'] = row?.company?.id || this.selectedClient?.id;
      }
    }

    const schedulerForm: UntypedFormGroup = new UntypedFormGroup({
      end_time: new FormControl(getFormattedTime(shiftEnd)),
      start_time: new FormControl(getFormattedTime(shiftStart)),
      start_day: new FormControl(getFormattedDate(startDay)),
      end_day: new FormControl(
        getFormattedDate(new Date(endDay)),
        Validators.required,
      ),

      repeat_times: new UntypedFormControl(null),
      repeat_type: new UntypedFormControl('once', Validators.required),
      repeat_details: new UntypedFormControl([]),
      repeat_interval: new UntypedFormControl(1, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
      ]),
      position: new UntypedFormControl(null, []),
      week_day: new UntypedFormControl(null, []),
      month_repeat_case: new UntypedFormControl(null, []),
    });

    const dialogRef = this.dialogService.open(
      template,
      {
        data: { shift: shiftData, schedulerForm: schedulerForm, editingShift },
      },
      this.viewContainerRef,
    );
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
    if (!dialogResponse) return;
    const scheduleData: any = dialogResponse?.schedulerForm.value || {};

    sessionStorage.setItem(
      btoa('scheduleLastSavedTimes'),
      JSON.stringify({
        start_time: scheduleData?.start_time,
        end_time: scheduleData?.end_time,
      }),
    );

    if (editingShift) {
      scheduleData['start_day'] =
        formatDate(scheduleData?.start_day, 'yyyy-MM-dd', 'en') || '';
      scheduleData['end_day'] =
        formatDate(scheduleData?.end_day, 'yyyy-MM-dd', 'en') || '';

      const shiftUpdated = {
        ...dialogResponse?.shift,
        ...scheduleData,
        orginal_id: shiftData?.orginal_id || shiftData?.id,
        edited: true,
      };

      // this.spinnerService.show('Saving Change');
      this.rosterService
        .saveModifyShifts(
          {
            group_by: this.shiftDataGroupBy,
            drafted_changes: [shiftUpdated],
            ids_to_be_deleted: [],
          },
          { shift_type: this.getShiftTypeString(), ...this.getStartEndDays() },
        )
        .then((response: any) => {
          if (response?.status !== 'success') {
            this.spinnerService.hide();
            this.toasterService.setMessage({ errorMessage: response?.message });
            return;
          }
          this.selectedGlobalAction = '';

          // this.spinnerService.show('Updating Data');
          if ((response?.shift_ids || [])?.lenth == 1) {
            this.updatedShiftIds = response?.shift_ids || [];
            this.getShiftDataForWeek();
          } else {
            this.updatedShiftIds = [];
            this.getShiftData();
          }
        });

      return;
    }

    this.selectedGlobalAction = '';
    if (this.selectedJobType?.type_identity == 6) {
      const draftDict: any = {
        runSheetName: dialogResponse?.shift?.name,
        checkListData: [],
        schedulerForm: dialogResponse?.schedulerForm?.value,
      };
      if (dialogResponse?.shift?.assignee_id) {
        draftDict['assignedGuardData'] = {
          id: dialogResponse?.shift?.assignee_id,
          full_name: dialogResponse?.shift?.assignee_name,
        };
      }
      sessionStorage.setItem(btoa('runsheetDraft'), JSON.stringify(draftDict));

      this.router.navigate(['/add-runsheet', {}]);
    } else if (this.selectedJobType?.type_identity == 4) {
      sessionStorage.setItem(
        btoa('schedulePrefilledData'),
        JSON.stringify({
          shift: dialogResponse?.shift,
          schedule: dialogResponse?.schedulerForm?.value,
        }),
      );
      this.router.navigate(['/add-job'], { fragment: 'roster' });
    } else {
      this.onAddNormalJob(dialogResponse);
    }
  }
  startsWithSearch = (field: string, searchStr: string) => {
    const regex = new RegExp(`\\b${searchStr}`, 'i');
    return regex?.test(field);
  };
  onUserLookup(event: any) {
    const searchStr = (event?.target?.value || '')?.toLowerCase();
    this.userSearchString = searchStr;
    this.userLookupListData = this.userListData
      ?.filter((user: any) => this.startsWithSearch(user?.full_name, searchStr))
      ?.slice(0, 10);
  }
  onUserSelect(data: any, userData: any) {
    let shiftData = data?.shift || {};
    shiftData = {
      ...shiftData,
      assignee_id: userData?.id,
      assignee_name: userData?.full_name,
    };
    this.userSearchString = userData?.full_name;

    data['shift'] = shiftData;
  }

  onSiteLookup(event: any) {
    const searchStr = (event?.target?.value || '')?.toLowerCase();
    if (this.selectedClient?.id == 1) {
      this.onSiteSearch(searchStr);
      return;
    }
    this.siteLookupListData = this.siteListData
      ?.filter((site: any) =>
        this.startsWithSearch(site?.company_name, searchStr),
      )
      ?.slice(0, 10);
  }
  onSiteSearch(searchString?: string) {
    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteLookupListData = res?.data?.splice(0, 10);
        }
      });
  }
  onSiteSelect(data: any, siteData: any) {
    let shiftData = data?.shift || {};
    shiftData = {
      ...shiftData,
      site_id: siteData?.id,
      site_name: siteData?.company_name,
      company_id: siteData?.company?.id,
    };

    data['shift'] = shiftData;
  }

  editShiftInfo(data: any, source: 'assignee' | 'site') {
    let shiftData = data?.shift || {};

    switch (source) {
      case 'assignee':
        shiftData = {
          ...shiftData,
          assignee_id: '',
          assignee_name: '',
        };
        break;
      case 'site':
        shiftData = {
          ...shiftData,
          site_id: '',
          site_name: '',
        };
        break;
    }

    data['shift'] = shiftData;

    switch (source) {
      case 'assignee':
        this.shiftFocus('userLookupFieldId');
        break;
      case 'site':
        this.shiftFocus('siteLookupFieldId');
        break;
    }
  }
  onAddNormalJob(shiftData: any) {
    // this.spinnerService.show('Adding Shifts');
    let timezoneOffset = new Date();
    let data: any = {
      job_type_id: this.selectedJobType.id,
      company_id: shiftData?.shift?.company_id,
      location: [shiftData?.shift?.site_id],
      is_abandoned: false,
      request: '',
      internal_notes: '',
      new_assignee: shiftData?.shift?.assignee_id || '',
      location_contact_id: '',
      time_offset: timezoneOffset.getTimezoneOffset(),
      position: shiftData?.shift?.position || '',
      external_job_id: shiftData?.shift?.external_job_id || '',
    };

    const scheduleData = shiftData?.schedulerForm.value || {};
    scheduleData['start_day'] =
      formatDate(scheduleData?.start_day, 'yyyy-MM-dd', 'en') || '';
    scheduleData['end_day'] =
      formatDate(scheduleData?.end_day, 'yyyy-MM-dd', 'en') || '';

    data = { ...scheduleData, ...data };

    this.jobService
      .createJob(data, { save_schedule: 1 })
      .then((res: any) => {
        if (res['status'] == 'success') {
          // this.spinnerService.show('Fetching Shifts');
          this.getShiftData();
        } else {
          this.toasterService.setMessage({
            errorMessage: res['message'],
            successMessage: '',
          });
          this.spinnerService.hide();
        }
      })
      .catch((error: any) => {
        if (error) {
        }
      });
  }
  getWeatherInfo() {
    const body = {
      subscriber_address: 1,
    };
    this.jobService.getWeatherInfo(body).subscribe((response: any) => {
      if (response?.status === 'success') {
        this.weatherData = response?.data?.forecast_weather;
        this.weatherAddressInfo = response?.address_data;
      }
    });
  }
  openWeatherTemplate(
    template: TemplateRef<any>,
    weatherData: any,
    selectedDate: any,
  ) {
    const dayWeather =
      weatherData?.[formatDate(new Date(selectedDate), 'yyyy-MM-dd', 'en_US')];

    this.dialogService.open(
      template,
      {
        data: {
          weatherData: dayWeather,
          selectedDate: selectedDate,
          weatherKeys: [
            ...Object.keys(dayWeather)?.filter(
              (key) => !['Condition', 'Description'].includes(key),
            ),
          ],
        },
      },
      this.viewContainerRef,
    );
  }
  getTimeDifference(shiftData: any) {
    const [selectedShiftStart, selectedShiftEnd] =
      this.getStartAndEndDateTime(shiftData);
    return selectedShiftEnd - selectedShiftStart;
  }

  async copyShiftsToNextWeek(template: any, singleRow?: any) {
    const dialogRef = this.dialogService.open(
      template,
      { data: { removeAssigneeWhileCopying: 0 } },
      this.viewContainerRef,
    );
    const dialogResponse = await firstValueFrom(dialogRef?.afterClosed());

    if (!dialogResponse) return;

    this.removeAssigneeWhileCopying =
      dialogResponse?.removeAssigneeWhileCopying || false;

    let shiftsToBeCopied: any = [];

    if (singleRow?.id) {
      const key = this.shiftDataGroupBy === 'site' ? 'site_id' : 'assignee_id';

      shiftsToBeCopied = this.filteredRosteredList?.filter(
        (shift: any) => shift?.[key] == singleRow?.id,
      );
    } else {
      shiftsToBeCopied = JSON.parse(JSON.stringify(this.filteredRosteredList));
    }

    this.weekCopiedShifts = JSON.parse(JSON.stringify(shiftsToBeCopied));

    this.isCopyingWeek = true;
    this.isEnteringNewWeek = false;

    setTimeout(() => {
      this.isCopyingWeek = false;
      this.onDateSelect('week', '+');

      this.isEnteringNewWeek = true;

      setTimeout(() => {
        this.isEnteringNewWeek = false;
      }, 1000);
    }, 1000);
  }
  async openTemplate(source: string, template?: any) {
    let dialogData: any = {};

    switch (source) {
      case 'filterShifts':
        this.onSiteSearch('');
        break;
      case 'publishShifts':
        const assigneeDict: any = {};
        this.shiftsToPublishListFiltered?.forEach((shift: any) => {
          if (shift?.assignee_id) {
            if (!(shift?.assignee_id in assigneeDict)) {
              assigneeDict[shift?.assignee_id] = {
                count: 0,
                assignee_id: shift?.assignee_id,
                assignee_name: shift?.assignee_name,
              };
            }
            assigneeDict[shift?.assignee_id]['count'] += 1;
          }
        });
        dialogData = Object.values(assigneeDict);

        break;
    }

    const dialogRef = this.dialogService.open(
      template,
      { data: dialogData },
      this.viewContainerRef,
    );
    const dialogResponse = await firstValueFrom(dialogRef?.afterClosed());
    if (dialogResponse) {
      switch (source) {
        case 'filterShifts':
          this.shiftFilterData = JSON.parse(
            JSON.stringify({ ...this.shiftFilterData }),
          );
          this.updateSessionStorage();
          this.updateRosterMap();
          break;
        case 'publishShifts':
          const currentFutureDays = this.getPublishedHistoryWeekDays();
          if (!currentFutureDays?.length) return;
          let reqBody: any = {
            job_ids: [
              ...new Set(
                this.shiftsToPublishListFiltered?.map((job: any) => job?.id),
              ),
            ],
            event_dates: [
              ...new Set(
                currentFutureDays?.map((date: any) => new Date(date).getTime()),
              ),
            ],
          };

          this.rsService
            .publishRosterData(reqBody)
            .subscribe((response: any) => {
              if (response?.status === 'success') {
                this.spinnerService.hide();
                this.shiftsToPublish = [];
                this.shiftsToPublishListFiltered = [];

                this.toasterService.setMessage({
                  errorMessage: '',
                  successMessage: 'Published',
                });
              } else {
                this.spinnerService.hide();
                this.toasterService.setMessage({
                  errorMessage: response?.message,
                  successMessage: '',
                });
              }
            });
          break;
      }
    }
  }
  getPublishedHistoryWeekDays() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return this.weekDays?.filter(
      (day: any) => new Date(day).getTime() >= today.getTime(),
    );
  }
  checkIfPublishingRequired() {
    if (!this.selectedJobType?.id) return false;
    const requireAcceptance =
      this.selectedJobType?.requires_acceptance || false;
    //https://app.shortcut.com/sendem/story/13260/remove-publish-shifts-for-job-types-without-shift-acceptance-logic
    if ([6].includes(this.selectedJobType?.type_identity) || !requireAcceptance)
      return false;

    const currentFutureDays = this.getPublishedHistoryWeekDays();

    if (!currentFutureDays?.length) return false;

    return currentFutureDays;
  }
  getPublishedHistory() {
    const currentFutureDays = this.checkIfPublishingRequired();
    if (!currentFutureDays) return;

    // no need to check for  publish shifts histiory for past weeks

    let reqBody: any = {
      event_dates: [
        ...new Set(
          currentFutureDays?.map((date: any) => new Date(date).getTime()),
        ),
      ],
    };
    this.rsService
      .publishRosterData(reqBody, { get_published_history: 1 })
      .subscribe((response: any) => {
        if (response?.status === 'success') {
          this.publishedHistoryData = response?.data || {};
          this.checkAndFilterShiftsToPublish();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response?.message,
            successMessage: '',
          });
        }
      });
  }
  checkAndFilterShiftsToPublish() {
    this.shiftsToPublishListFiltered = [];
    if (!this.filteredRosteredList?.length || this.isPastWeek) return;
    const currentFutureDays = this.checkIfPublishingRequired();
    if (!currentFutureDays) return;

    if (this.publishedHistoryData) {
      const today = this.getOnlyDateFromDateTime();
      this.filteredRosteredList?.forEach((shift: any) => {
        const shiftAlreadySent =
          (this.getOnlyDateFromDateTime(shift?.event_date) >= today &&
            (!shift?.assignee_id ||
              (this.publishedHistoryData?.[shift?.id] || [])?.includes(
                shift?.assignee_id,
              ))) ||
          [2, 3].includes(shift?.status_dict?.identity);
        this.getOnlyDateFromDateTime(shift?.event_date) < today;

        if (!shiftAlreadySent) this.shiftsToPublishListFiltered.push(shift);
      });
    } else {
      setTimeout(() => {
        this.checkAndFilterShiftsToPublish();
      }, 1500);
    }
  }

  async onClickShift(shiftData: any) {
    if (this.isAdminUser || this.isDispatcherUser) {
      if (this.selectedGlobalAction == 'duplicate') {
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Are you sure?',
            message:
              this.selectedJobType?.type_identity == 6
                ? `Press confirm to duplicate runsheet.`
                : 'Confirm duplicating the shift with the same job details',
          },
        });
        const dResponse = await firstValueFrom(dialogRef.afterClosed());

        if (dResponse === true) {
          if (this.selectedJobType?.type_identity == 6) {
            this.router.navigate([
              '/add-runsheet',
              { rKey: String(shiftData?.id) },
            ]);
          } else {
            sessionStorage.setItem(
              btoa('rosterCopyJobInfo'),
              JSON.stringify({
                job_type_dict: {
                  id: this.selectedJobType?.id,
                  type_identity: this.selectedJobType?.type_identity,
                },
                id: shiftData?.id,
              }),
            );
            this.router.navigate(['/add-job'], { fragment: 'roster' });
          }
        }

        return;
      }
      if (this.selectedGlobalAction == 'delete') {
        this.selectedGlobalAction = '';
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Are you sure?',
            message: 'THIS ACTION CANNOT BE UNDONE!',
            btn2Detail: { text: 'Delete', class: 'btn-danger' },
          },
        });
        const dResponse = await firstValueFrom(dialogRef.afterClosed());

        if (dResponse === true) {
          // this.onDeleteShift(shiftData);
          this.dataBackupDict.idsToBeDeleted = new Set([shiftData?.id]);
          this.dataBackupDict.draftedChanges = [];
          this.onSaveChanges();
        }
        return;
      }
      if (!this.largeView) {
        this.onRedirectShift(shiftData);
        return;
      }
    } else {
      this.onRedirectShift(shiftData);
      return;
    }

    this.selectedShiftBackup = {};
    this.selectedShift = shiftData;

    if (!this.isPastScheduleCheck(shiftData?.event_date)) {
      this.selectedShiftBackup = { ...shiftData };
      this.userSearchString = shiftData?.assignee_name;
    }
  }
  shiftEditChanges() {
    if (this.selectedShiftBackup?.draftedItem) return;
    if (!this.selectedShift?.start_time) return;
    if (
      this.selectedShiftBackup?.assignee_id != this.selectedShift?.assignee_id
    ) {
      const selectedShift = { ...this.selectedShift };
      return {
        ...selectedShift,

        orginal_id: selectedShift?.orginal_id || selectedShift?.id,
        edited: true,
        copied: false,
        draftedItem: true,
      };
    }
    const shiftChanged =
      this.selectedShiftBackup?.end_time &&
      this.selectedShift?.start_time &&
      (this.selectedShiftBackup?.start_time != this.selectedShift?.start_time ||
        this.selectedShiftBackup?.end_time != this.selectedShift?.end_time);

    if (!shiftChanged) return;
    const selectedShift = { ...this.selectedShift };
    const [selectedShiftStart, selectedShiftEnd] = this.getStartAndEndDateTime(
      this.selectedShift,
    );

    return {
      ...selectedShift,
      ...{
        start_day: formatDate(selectedShiftStart, 'yyyy-MM-dd', 'en') || '',
        end_day: formatDate(selectedShiftEnd, 'yyyy-MM-dd', 'en') || '',
        repeat_type: 'once',
      },
      orginal_id: selectedShift?.orginal_id || selectedShift?.id,
      edited: true,
    };
  }
  onUpdateShift() {
    // this.spinnerService.show('Saving Change');
    const shiftUpdated = this.shiftEditChanges();

    if (!shiftUpdated) return;
    this.rosterService
      .saveModifyShifts(
        {
          group_by: this.shiftDataGroupBy,
          drafted_changes: [shiftUpdated],
          ids_to_be_deleted: [],
        },
        { shift_type: this.getShiftTypeString(), ...this.getStartEndDays() },
      )
      .then((response: any) => {
        if (response?.status !== 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({ errorMessage: response?.message });
          return;
        }
        this.selectedGlobalAction = '';
        this.deselectShift();

        // this.spinnerService.show('Updating Data');
        if ((response?.shift_ids || [])?.lenth == 1) {
          this.updatedShiftIds = response?.shift_ids || [];
          this.getShiftDataForWeek();
        } else {
          this.updatedShiftIds = [];
          this.getShiftData();
        }
      });
  }
  onShiftReset() {
    this.selectedShift = { ...this.selectedShiftBackup };
  }
  isPastScheduleCheck(date: any) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);

    return d.getTime() < this.todayInMs;
  }
  isFutureScheduleCheck(date: any) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);

    return d.getTime() > this.todayInMs;
  }

  async onClearAllShifts() {
    this.selectedGlobalAction = 'delete';
    this.deselectShift();
    const filteredIds = new Set(
      this.filteredRosteredList
        ?.filter((shift: any) => this.isFutureScheduleCheck(shift?.event_date))
        ?.map((item: any) => item?.id),
    );
    this.rosterDataList = this.rosterDataList?.filter(
      (item: any) => !filteredIds.has(item?.id),
    );
    this.getDraggedNCopiedChanges('drag');
    // const filteredDataList = this.rosterDataList?.filter((item:any) =>  )

    // const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
    //   data: {
    //     title: 'Are you sure?',
    //     message: 'THIS ACTION CANNOT BE UNDONE!',
    //     btn2Detail: { text: 'Delete', class: 'btn-danger' },
    //   },
    // });
    // const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
    // if (dialogResponse) {
    // const idsToBeDeleted = this.rosterDataList?.map((item: any) => item?.id);
    // this.rosterDataList = [];
    // this.dataBackupDict = {};
    // this.updateRosterMap(this.rosterDataList);
    // this.rosterService
    //   .saveModifyShifts(
    //     {
    //       group_by: this.shiftDataGroupBy,
    //       drafted_changes: [],
    //       ids_to_be_deleted: [...new Set(idsToBeDeleted)],
    //     },
    //     { shift_type: this.getShiftTypeString(), ...this.getStartEndDays() },
    //   )
    //   .then((response: any) => {
    //     if (response?.status !== 'success') {
    //       this.spinnerService.hide();
    //       this.toasterService.setMessage({ errorMessage: response?.message });
    //       return;
    //     }
    //     this.selectedGlobalAction = '';
    //     this.getShiftData();
    //   });
    // }
  }
  resetAndCallLeaveList() {
    // this.userLeaveData = {};
    // this.getUsersLeaveList();
  }
  getUsersLeaveList(nextCursor?: string) {
    // let params: any = {
    //   rows: 5,
    //   ...this.getStartEndDays(),
    //   cursor_pagination: 1,
    //   status_ids: JSON.stringify([1]),
    // };
    // if (nextCursor) params.next_cursor = nextCursor;
    // this.rosterService.getAllLeaves(params).subscribe((response: any) => {
    //   const resData = response?.data || [];
    //   const groupedLeaveData: any = {};
    //   resData.forEach((leave: any) => {
    //     const uniqueId = getScheduleCellKey(
    //       leave?.assignee_uuid,
    //       new Date(formatDate(leave.leave_date, 'yyyy-MM-dd', 'en_US')),
    //     );
    //     if (!uniqueId) return;
    //     if (!groupedLeaveData[uniqueId]) {
    //       groupedLeaveData[uniqueId] = [];
    //     }
    //     groupedLeaveData[uniqueId].push(leave);
    //   });
    //   this.userLeaveData = {
    //     ...(this.userLeaveData || {}),
    //     ...(groupedLeaveData || {}),
    //   };
    //   if (response?.next_cursor) this.getUsersLeaveList(response?.next_cursor);
    // });
  }
  onEditUserOnSelectedShift(userData: any) {
    if (userData?.key == 0) {
      this.userSearchString = '';
      this.selectedShift = {
        ...(this.selectedShift || {}),
        assignee_id: '',
        assignee_name: '',
      };
    } else {
      this.selectedShift = {
        ...(this.selectedShift || {}),
        assignee_id: userData?.id,
        assignee_name: userData?.full_name,
      };
    }
    this.updateShiftInDraftedChanges();
  }
  updateShiftInDraftedChanges() {
    if (!this.selectedShift?.id) return;
    const draftedShifts = JSON.parse(
      JSON.stringify(this.dataBackupDict.draftedChanges),
    );
    const shiftDraftIndex = draftedShifts?.findIndex(
      (item: any) => item?.shiftUniqueId == this.selectedShift?.id,
    );

    if (shiftDraftIndex > -1) {
      this.selectedGlobalAction = '';

      draftedShifts[shiftDraftIndex] = {
        ...draftedShifts[shiftDraftIndex],
        ...this.selectedShift,
      };
      this.dataBackupDict.draftedChanges = JSON.parse(
        JSON.stringify(draftedShifts),
      );
    }
  }
  copySelectedShift(pastShift: boolean) {
    if (!this.isCurrentWeek && pastShift) {
      // past shifts that are in the past weeks
      if ([6, 4].includes(this.selectedJobType?.type_identity)) {
        // they can onlt be grouped by users
        this.selectedGlobalAction = 'copy';
        this.onDateSelect(this.largeView ? 'week' : 'day', '=');
        return;
      }
      if (this.selectedClient?.id == 1 && this.shiftDataGroupBy == 'site') {
        // all shifts is selected, which means current week may not have any shifts and therefore user wont be able to click past btn
        this.selectedGlobalAction = 'duplicate';
        this.onClickShift(this.selectedShift);
        return;
      }
      if (this.selectedClient?.id) {
        // they can onlt be grouped by users/sites but the items will be there
        this.selectedGlobalAction = 'copy';
        this.onDateSelect(this.largeView ? 'week' : 'day', '=');
        return;
      }
      this.selectedGlobalAction = 'copy';
    } else {
      this.selectedGlobalAction = 'copy';
    }
  }
  onShiftFilterSelect(selectedItem: any, source: 'site' | 'person' = 'site') {
    if (source == 'site') {
      const index = this.shiftFilterData?.selectedSites?.findIndex(
        (item: any) => item?.id == selectedItem?.id,
      );
      if (index > -1) {
        this.shiftFilterData?.selectedSites?.splice(index, 1);
      } else {
        this.shiftFilterData?.selectedSites.push(selectedItem);
      }
      setTimeout(() => {
        var element = <HTMLInputElement>(
          document.getElementById('shiftFilterSiteLookupFieldId')
        );
        element.value = '';
        element?.focus();
      }, 100);
    } else {
      const index = this.shiftFilterData?.selectedUsers?.findIndex(
        (item: any) => item?.id == selectedItem?.id,
      );
      if (index > -1) {
        this.shiftFilterData?.selectedUsers?.splice(index, 1);
      } else {
        this.shiftFilterData?.selectedUsers.push(selectedItem);
      }
      setTimeout(() => {
        var element = <HTMLInputElement>(
          document.getElementById('shiftFilterUserLookupFieldId')
        );
        element.value = '';
        element?.focus();
      }, 100);
    }
  }
  openPrintDialog() {
    this.spinnerService.show('Formatting Data');
    this.selectedGlobalAction = 'print';
    const style = document.createElement('style');
    style.id = 'roster-page-style';
    style.media = 'print';
    style.innerHTML = `
    @page {
      size: A4 landscape;
      margin: 5px !important;
    }
  `;
    document.head.appendChild(style);

    setTimeout(() => {
      window.print();
      this.spinnerService.hide();
    }, 250);

    window.onafterprint = () => {
      document.getElementById('roster-page-style')?.remove();
      this.selectedGlobalAction = '';
      window.onafterprint = null;
    };
  }
  getOnsiteOffsiteInfoForJobs(jobIds: any) {
    const existingJobIds = new Set(
      Object.keys(this.jobShiftOnsiteOffsiteInfo || {}),
    );

    const newJobIds = jobIds?.filter((_id: any) => !existingJobIds.has(_id));

    if (!newJobIds?.length) return;
    this.userService
      .getUserUpdateLog(
        { job_ids: jobIds, event_type: 'job_onsite_offiste_info' },
        {},
      )
      .subscribe((response: any) => {
        this.jobShiftOnsiteOffsiteInfo = {
          ...this.jobShiftOnsiteOffsiteInfo,
          ...response?.data,
        };
      });
  }
}
